const document = {
  state: {
    fileList: []
  },
  mutations: {
    setFileList(state, val) {
      state.fileList = val
    },
  }
};
export default document;



// WEBPACK FOOTER //
// ./src/store/modules/document.js